// extracted by extract-css-chunks-webpack-plugin
module.exports = {"deleteBtn":"remove-reg-item-action__deleteBtn__3-U3e"};